import React from "react";
import { func, node, string } from "prop-types";
import Link from "@insightfulscience/atomic-react/Link";
import Image from "@insightfulscience/atomic-react/Image";
import Heading from "@insightfulscience/atomic-react/Heading";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";

const CardMini = ({ id, src, scrollTo, children }) => (
	<Row py className="card-mini__image-block">
		<Col>
			<Link href={`#${id}`} onClick={scrollTo}>
				<Image src={src} />
			</Link>
		</Col>
		<Col>
			<Heading sx={{ fontSize: "m" }} spacing={{ mb: 0, mt: "m7" }}>
				<Link href={`#${id}`} onClick={scrollTo} color="4" hoverColor="white">
					{children}
				</Link>
			</Heading>
		</Col>
	</Row>
);

CardMini.propTypes = {
	id: string.isRequired,
	src: string.isRequired,
	children: node.isRequired,
	scrollTo: func.isRequired,
};

const HeroIconSectionGraphpad = () => {
	const scrollToSection = event => {
		event.preventDefault();
		const element = event.target;
		const isImg = element.tagName.toLowerCase() === "img";
		const href = isImg ? element.parentElement.getAttribute("href") : element.getAttribute("href");
		const id = href.substring(1, href.length);
		document.getElementById(id).scrollIntoView({ behavior: "smooth" });
	};

	return (
		<Row className="medium-up-2 large-up-4">
			<Col utility={{ align: { self: "center" } }}>
				<CardMini
					scrollTo={scrollToSection}
					id="getting-started"
					src="/images/graphpad/resources/tutorials.svg"
				>
					Getting Started <br /> with Prism
				</CardMini>
			</Col>
			<Col utility={{ align: { self: "center" } }}>
				<CardMini
					scrollTo={scrollToSection}
					id="tutorials-guides"
					src="/images/graphpad/resources/guides.svg"
				>
					Guides
				</CardMini>
			</Col>
			<Col utility={{ align: { self: "center" } }}>
				<CardMini
					scrollTo={scrollToSection}
					id="academy"
					src="/images/graphpad/resources/prism-acad-i.svg"
				>
					Prism Academy
				</CardMini>
			</Col>
			<Col utility={{ align: { self: "center" } }}>
				<CardMini
					scrollTo={scrollToSection}
					id="quick-calcs"
					src="/images/graphpad/resources/quickcalcs.svg"
				>
					QuickCalcs
				</CardMini>
			</Col>
		</Row>
	);
};

export default HeroIconSectionGraphpad;
